module.exports = __webpack_public_path__ + "html/offer-form.template.html";